import { useEffect, useMemo, useReducer, useRef, useState } from "react";
import hbrIcon from "../otherImg/hbrlitenewicon.png";
import Authaxios from "./Authaxios";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import { ConstVariables } from "./ConstantVariables";


const ChangePassword = ({user_email, onSuccess}) => {
    const [confirmPwd,setConfirmPwd]=useState("");
    const [passwd,setpasswd]=useState("");
    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);
    const [success, setSuccess] = useState(false);
    const [state,dispatch]=useReducer(reducer,{alertMessage: "", showAlert: false, userVerified: false, vcode: "", showConfirmDialog: false});
    const [loading,setLoading]=useState(false);
    const errRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const PWD_REGEX = useMemo(()=>/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/, []);

  
   
    useEffect(() => {
        setValidPwd(PWD_REGEX.test(passwd));
    }, [passwd,PWD_REGEX]);

    const handleChangePassword=async(e)=>{
        e.preventDefault()
        const verifiedPwd = PWD_REGEX.test(passwd);
        if (!verifiedPwd) {
            dispatch({type: actionConsts.ALERT_MESSAGE,payload: "invalid password format"});
            dispatch({type: actionConsts.SHOWALERT,payload: true});
            setErrMsg("invalid pasword format");
            return;
        }
        if (passwd !== confirmPwd) {
            dispatch({type: actionConsts.ALERT_MESSAGE,payload: "Confirm password should be the same as the new password"});
            dispatch({type: actionConsts.SHOWALERT,payload: true});
            setErrMsg("password mismatch");
            return;
        }

        try {
            setLoading(true);
            await Authaxios.post("/changePassword",
                JSON.stringify({user_email, password: passwd, api_key:process.env.REACT_APP_CONNECTERE_KEY}),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: false
                }
            );
            setLoading(false);
            setSuccess(true);
        } catch (error) {
            if (!error?.response) {
                setErrMsg(ConstVariables.NO_SERVER_RESPONSE);
            }else if (error?.response.status === 500) {
                setErrMsg(ConstVariables.SERVICE_UNAVAILABLE);
            }else if (error?.response.status === 404) {
                setErrMsg("User account not found");
            }else{
                setErrMsg(ConstVariables.UNKNOWN_ERROR);
            }
            setLoading(false);
            errRef.current.focus();
        }
    };


    return ( 
        <div className="useraccount">
            {state.showAlert && 
            <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={()=>dispatch({type: actionConsts.SHOWALERT,payload: false})} />
            }

                {loading && 
                    <div style={{
                        position:"absolute",
                        top:"50%",
                        left:"45%",
                        width:"50px",
                        height:"50px",
                        border: "5px solid #00000050",
                        borderTop: "5px solid #eb268f",
                        borderBottom: "5px solid Teal",
                        borderRadius: "50%",
                        animation: "spin2 2s linear infinite",
                        zIndex:"3"
                        }}>
                    </div>
                }

              <div className="formWrapper">

                    <div className="arrangeformheading">
                        <img src={hbrIcon} alt="" />
                        <h3>Password Reset</h3>
                    </div>

                    <p ref={errRef} className={errMsg ? "errmsg" : "hideerrmsg"} aria-live="assertive">{errMsg}</p>

                    <form onSubmit={handleChangePassword} className="formcontents">
                            <input
                            className="no-select-field"
                            type="password" 
                            placeholder="New password" 
                            value={passwd}  
                            onChange={e => setpasswd(e.target.value.trim())}
                            required
                            aria-invalid={validPwd ? "false" : "true"}
                            aria-describedby="pwdguide"
                            onFocus={() => setPwdFocus(true)}
                            onBlur={() => setPwdFocus(false)}
                            onContextMenu={(e)=>e.preventDefault()}
                            onMouseUp={(e) => e.preventDefault()}
                            onDrag={(e)=>e.preventDefault()}
                            onPaste={(e)=>e.preventDefault()}
                            onSelect={(e)=>e.preventDefault()}
                            />

                            <p id="pwdguide" className={pwdFocus && !validPwd ? "instructions" : "offscreen"}>
                                must be between 8 to 24 characters.<br/>
                                password must include uppercase and lowercase letters, a number and a special character.<br/>
                                special characters may include: <span aria-label="exclamation mark">!</span> <span aria-label="at symbol">@</span> <span aria-label="hashtag">#</span> <span aria-label="dollar sign">$</span> <span aria-label="percent">%</span>
                            </p>

                            <input
                            className="no-select-field"
                            type="password" 
                            placeholder="Confirm password" 
                            value={confirmPwd}  
                            onChange={e => setConfirmPwd(e.target.value.trim())}
                            required
                            onContextMenu={(e)=>e.preventDefault()}
                            onMouseUp={(e) => e.preventDefault()}
                            onDrag={(e)=>e.preventDefault()}
                            onPaste={(e)=>e.preventDefault()}
                            onSelect={(e)=>e.preventDefault()}
                            />

                    </form>

                    {!success ?
                          (<button disabled={state.showAlert} style={{border: "none", fontWeight:"bold", backgroundColor:"white", padding:"10px", cursor:"pointer"}} 
                          onClick={(e)=>handleChangePassword(e)}>
                              Change Password
                          </button>
                          )
                          :
                          (
                            <button disabled={state.showAlert} style={{border: "none", borderRadius:"10px", fontWeight:"bold", backgroundColor:"#0E78F9",color: "white", padding:"10px", cursor:"pointer"}} 
                          onClick={()=>onSuccess()}>
                              Login with new password
                          </button>
                          )
                    }
              </div>
        </div>
     );
}
export default ChangePassword;